import { Container, Form, Button, Card, Collapse, Modal } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import {
  getCoachParticipants,
  createCoachParticipant,
  updateCoachParticipant,
  deleteCoachParticipant,
  getCategories,
  getParticipantsMessage,
  getDataChiusuraIscrizioni
} from '../api/api.js';

export default function Participants() {
  const [participants, setParticipants] = useState([]);
  const [disciplines, setDisciplines] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editData, setEditData] = useState({});
  const [expandedIds, setExpandedIds] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [showAddForm, setShowAddForm] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const [dataChiusura, setDataChiusura] = useState(null);
  const [chiuso, setChiuso] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [participantToDelete, setParticipantToDelete] = useState(null);
  const [language, setLanguage] = useState("it");

  const translations = {
    it: {
      title: "Partecipanti",
      filterPlaceholder: "Filtra per nome o cognome",
      addButton: "Aggiungi Nuovo Partecipante",
      cancelAdd: "Annulla Nuovo Partecipante",
      addParticipant: "Salva Partecipante",
      registered: "ISCRITTO",
      notRegistered: "NON ISCRITTO",
      edit: "Modifica",
      cancel: "Annulla",
      details: "Dettagli",
      close: "Chiudi",
      delete: "Elimina",
      confirmDeleteTitle: "Conferma Eliminazione",
      confirmDeleteBody: "Sei sicuro di voler eliminare",
      cancelDelete: "Annulla",
      confirmDelete: "Elimina",
      male: "Maschio",
      female: "Femmina",
      closedOn: "Le iscrizioni sono chiuse dal",
      willCloseOn: "Le iscrizioni chiuderanno il",
      bothDisciplines: "Abbina Per Entrambe le Discipline",
      doubleCostWarning: "Sono consapevole che gareggiare in due discipline comporta un supplemento di costo.",
      selectPlaceholder: "Seleziona...",
      alertTitle: "ATTENZIONE",
      alertBody: "I seguenti atleti risultano NON ISCRITTI perché mancano dati obbligatori:",
      fields: {
        cognome: "Cognome *",
        nome: "Nome *",
        data_nascita: "Data di nascita *",
        sesso: "Sesso *",
        codice_fiscale: "Codice fiscale",
        disciplina: "Disciplina *",
        disciplina2: "Seconda disciplina",
        doppio_abbinamento: "Doppio abbinamento",
        peso: "Peso (kg) *",
        anni_di_pratica: "Anni di pratica *",
        cintura: "Cintura",
        numero_di_match: "Numero di match *",
        classe: "Classe (Contatto Pieno)",
        ente: "Ente",
        tessera: "Tessera",
        note: "Note",
      },
    },
    en: {
      title: "Participants",
      filterPlaceholder: "Filter by name or surname",
      addButton: "Add New Participant",
      cancelAdd: "Cancel New Participant",
      addParticipant: "Save Participant",
      registered: "REGISTERED",
      notRegistered: "NOT REGISTERED",
      edit: "Edit",
      cancel: "Cancel",
      details: "Details",
      close: "Close",
      delete: "Delete",
      confirmDeleteTitle: "Confirm Deletion",
      confirmDeleteBody: "Are you sure you want to delete",
      cancelDelete: "Cancel",
      confirmDelete: "Delete",
      male: "Male",
      female: "Female",
      closedOn: "Registrations closed on",
      willCloseOn: "Registrations will close on",
      bothDisciplines: "Match in Both Disciplines",
      doubleCostWarning: "I am aware of the extra cost for two disciplines.",
      selectPlaceholder: "Select...",
      alertTitle: "WARNING",
      alertBody: "The following athletes are NOT REGISTERED due to missing mandatory data:",
      fields: {
        cognome: "Surname *",
        nome: "Name *",
        data_nascita: "Date of Birth *",
        sesso: "Gender *",
        codice_fiscale: "Tax Code",
        disciplina: "Discipline *",
        disciplina2: "Second Discipline",
        doppio_abbinamento: "Double Registration",
        peso: "Weight (kg) *",
        anni_di_pratica: "Years of Practice *",
        cintura: "Belt",
        numero_di_match: "Number of Matches *",
        classe: "Class (Full Contact)",
        ente: "Organization",
        tessera: "Membership ID",
        note: "Notes",
      },
    },
  };

  const t = (key) => translations[language][key];

  const initialParticipant = {
    cognome: "", nome: "", data_nascita: "", sesso: "", codice_fiscale: "",
    disciplina: "", disciplina2: "", doppio_abbinamento: false, peso: "",
    anni_di_pratica: "", cintura: "", numero_di_match: "", classe: "",
    ente: "", tessera: "", note: "",
  };

  const [newParticipant, setNewParticipant] = useState(initialParticipant);

  // --- LOGICA DI VALIDAZIONE CAMPI OBBLIGATORI ---
  const isParticipantIncomplete = (p) => {
    return (
      !p.nome || !p.cognome || !p.data_nascita || !p.sesso || 
      !p.disciplina || !p.peso || 
      p.anni_di_pratica === "" || p.anni_di_pratica === null || 
      p.numero_di_match === "" || p.numero_di_match === null
    );
  };

  const incompleteParticipants = (participants || []).filter(isParticipantIncomplete);

  useEffect(() => {
    fetchParticipants();
    fetchDisciplines();
    loadParameters();
  }, []);

  const loadParameters = async () => {
    try {
      const res = await getParticipantsMessage();
      if (res.data.value !== '') setMessage(res.data.value);
      const res2 = await getDataChiusuraIscrizioni();
      if (res2.ok && res2.data?.value) {
        const data = new Date(res2.data.value);
        setDataChiusura(data);
        setChiuso(new Date() > data);
      }
    } catch (e) { setError("Errore nel caricamento dei parametri"); }
  };

  const fetchParticipants = async () => {
    try {
      const res = await getCoachParticipants();
      if (res.ok) setParticipants(res.data || []);
      else setError(res.error || "Errore nel recupero dei partecipanti");
    } catch { setError("Errore di rete"); }
  };

  const fetchDisciplines = async () => {
    try {
      const res = await getCategories();
      if (res.ok) setDisciplines(res.data || []);
    } catch { setError("Errore di rete"); }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewParticipant(prev => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const handleEditChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditData(prev => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (chiuso) return;
    try {
      const res = await createCoachParticipant(newParticipant);
      if (res.ok) {
        setNewParticipant(initialParticipant);
        setShowAddForm(false);
        fetchParticipants();
      } else setError(res.error);
    } catch { setError("Errore di rete"); }
  };

  const toggleEdit = (p) => {
    if (chiuso) return;
    if (editingId === p.id) {
      setEditingId(null);
      setEditData({});
    } else {
      setEditingId(p.id);
      setEditData({ ...p });
      setExpandedIds(prev => [...new Set([...prev, p.id])]);
    }
  };

  const saveEdit = async (id) => {
    if (chiuso) return;
    try {
      const res = await updateCoachParticipant(id, editData);
      if (res.ok) {
        setEditingId(null);
        setEditData({});
        fetchParticipants();
      } else setError(res.error);
    } catch (e) { setError("Errore di rete: " + e.message); }
  };

  const toggleExpand = (id) => {
    setExpandedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  const handleDeleteClick = (p) => {
    if (chiuso) return;
    setParticipantToDelete(p);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!participantToDelete || chiuso) return;
    try {
      const res = await deleteCoachParticipant(participantToDelete.id);
      if (res.ok) fetchParticipants();
    } catch { setError("Errore di rete"); }
    finally { setShowDeleteModal(false); setParticipantToDelete(null); }
  };

  const filteredParticipants = (participants || []).filter(p =>
    (p.nome || "").toLowerCase().includes(filterText.toLowerCase()) ||
    (p.cognome || "").toLowerCase().includes(filterText.toLowerCase())
  );

  const getInputProps = (field) => {
    if (field === "peso") return { type: "number", step: "0.1", min: "0" };
    if (["anni_di_pratica", "numero_di_match"].includes(field)) return { type: "number", step: "1", min: "0" };
    if (field === "data_nascita") return { type: "date" };
    if (field === "doppio_abbinamento") return { type: "checkbox" };
    return { type: "text" };
  };

  const isRequired = (field) => !["cintura", "disciplina2", "ente", "tessera", "codice_fiscale", "note", "classe"].includes(field);

  const renderField = (participantData, onChange, isEditing = true) =>
    Object.keys(initialParticipant).map((field) => {
      const inputProps = getInputProps(field);
      const value = participantData[field];

      if (field === "disciplina" || field === "disciplina2") {
        const availableDisciplines = (disciplines || []).filter(d => d.nome !== participantData[field === "disciplina" ? "disciplina2" : "disciplina"]);
        return (
          <Form.Group className="mb-2" key={field}>
            <Form.Label className="fw-bold text-uppercase small">{t("fields")[field]}</Form.Label>
            <Form.Select name={field} value={value} onChange={onChange} disabled={!isEditing || chiuso} required={field === "disciplina"}>
              <option value="">{t("selectPlaceholder")}</option>
              {availableDisciplines.map(d => <option key={d.id} value={d.nome}>{d.nome}</option>)}
            </Form.Select>
          </Form.Group>
        );
      }

      if (inputProps.type === "checkbox") {
        if (field === "doppio_abbinamento" && (!participantData.disciplina || !participantData.disciplina2)) return null;
        return (
          <Form.Group className="mb-2" key={field}>
            <Form.Check type="checkbox" label={t("bothDisciplines")} name={field} checked={value} onChange={onChange} disabled={!isEditing || chiuso} />
            {value && <div className="text-danger small fw-bold">{t("doubleCostWarning")}</div>}
          </Form.Group>
        );
      }

      if (field === "sesso") {
        return (
          <Form.Group className="mb-2" key={field}>
            <Form.Label className="fw-bold text-uppercase small">{t("fields")[field]}</Form.Label>
            <Form.Select name={field} value={value} onChange={onChange} disabled={!isEditing || chiuso} required>
              <option value="">{t("selectPlaceholder")}</option>
              <option value="M">{t("male")}</option>
              <option value="F">{t("female")}</option>
            </Form.Select>
          </Form.Group>
        );
      }

      return (
        <Form.Group className="mb-2" key={field}>
          <Form.Label className="fw-bold text-uppercase small">{t("fields")[field]}</Form.Label>
          <Form.Control {...inputProps} name={field} value={value || ""} onChange={onChange} readOnly={!isEditing || chiuso} required={isRequired(field)} />
        </Form.Group>
      );
    });

  return (
    <Container fluid className="p-2">
      <div className="text-end mb-2">
        <button className="btn btn-light btn-sm" onClick={() => setLanguage(language === "it" ? "en" : "it")}>
          {language === "it" ? "🇬🇧 English" : "🇮🇹 Italiano"}
        </button>
      </div>

      <h2 className="mb-3 text-center fw-bold">{t("title")}</h2>

      {dataChiusura && (
        <div className={`alert py-2 small ${chiuso ? "alert-danger" : "alert-info"}`}>
          {chiuso ? `${t("closedOn")} ${dataChiusura.toLocaleDateString()}` : `${t("willCloseOn")} ${dataChiusura.toLocaleDateString()}`}
        </div>
      )}

      {message && <div className="alert alert-warning small" style={{ whiteSpace: 'pre-line' }}>{message}</div>}
      {error && <div className="alert alert-danger py-2 small text-center">{error}</div>}

      {incompleteParticipants.length > 0 && (
        <div className="alert alert-danger shadow-sm border-start border-4 border-danger">
          <h6 className="fw-bold">{t("alertTitle")}</h6>
          <p className="small mb-2">{t("alertBody")}</p>
          <ul className="small mb-0 fw-bold">
            {incompleteParticipants.map(p => <li key={p.id}>{p.nome} {p.cognome}</li>)}
          </ul>
        </div>
      )}

      <Form.Group className="mb-3">
        <Form.Control type="text" placeholder={t("filterPlaceholder")} value={filterText} onChange={(e) => setFilterText(e.target.value)} />
      </Form.Group>

      <Button
        onClick={() => !chiuso && setShowAddForm(!showAddForm)}
        className="mb-3 w-100 fw-bold py-2"
        variant={chiuso ? "secondary" : "primary"}
        disabled={chiuso}
      >
        {showAddForm ? t("cancelAdd") : t("addButton")}
      </Button>

      <Collapse in={showAddForm}>
        <div>
          <Form onSubmit={handleSubmit} className="mb-4 p-3 bg-light rounded border shadow-sm">
            {renderField(newParticipant, handleInputChange, true)}
            <Button type="submit" className="w-100 mt-3 fw-bold">{t("addParticipant")}</Button>
          </Form>
        </div>
      </Collapse>

      <div className="d-flex flex-column gap-2">
        {filteredParticipants.map((p) => {
          const isExpanded = expandedIds.includes(p.id);
          const isEditing = editingId === p.id;
          const participantData = isEditing ? editData : p;
          const isIncomplete = isParticipantIncomplete(p);

          return (
            <Card key={p.id} className={`p-2 shadow-sm ${isIncomplete ? 'border-danger border-2' : 'border-success border-2'}`}>
              <div className="d-flex flex-wrap justify-content-between align-items-center">
                <div className="flex-grow-1">
                  <span className="fw-bold">{p.nome} {p.cognome}</span>
                  <span className={`ms-2 badge ${isIncomplete ? 'bg-danger' : 'bg-success'}`}>
                    {isIncomplete ? t("notRegistered") : t("registered")}
                  </span>
                </div>
                <div className="d-flex gap-1 mt-2 mt-sm-0">
                  <Button size="sm" variant="outline-primary" onClick={() => toggleEdit(p)} disabled={chiuso}>{isEditing ? t("cancel") : t("edit")}</Button>
                  <Button size="sm" variant="outline-secondary" onClick={() => toggleExpand(p.id)}>{isExpanded ? t("close") : t("details")}</Button>
                  <Button size="sm" variant="outline-danger" onClick={() => handleDeleteClick(p)} disabled={chiuso}>{t("delete")}</Button>
                </div>
              </div>

              <Collapse in={isExpanded}>
                <div className="mt-3 border-top pt-2">
                  {renderField(participantData, handleEditChange, isEditing)}
                  {isEditing && <Button size="sm" onClick={() => saveEdit(p.id)} className="w-100 mt-2 fw-bold" variant="success">SALVA MODIFICHE</Button>}
                </div>
              </Collapse>
            </Card>
          );
        })}
      </div>

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
        <Modal.Header closeButton><Modal.Title className="small fw-bold">{t("confirmDeleteTitle")}</Modal.Title></Modal.Header>
        <Modal.Body className="small">{t("confirmDeleteBody")} <strong>{participantToDelete?.nome} {participantToDelete?.cognome}</strong>?</Modal.Body>
        <Modal.Footer>
          <Button variant="light" size="sm" onClick={() => setShowDeleteModal(false)}>{t("cancelDelete")}</Button>
          <Button variant="danger" size="sm" onClick={confirmDelete}>{t("confirmDelete")}</Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}